import type { CastMember } from "@/types";

interface CastListProps {
  cast: CastMember[];
}

export default function CastList({ cast }: CastListProps) {
  return (
    <section>
      <div className="mb-5 flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-user-star-line text-lg"></i>
        </span>
        <h2 className="font-heading text-xl font-bold text-foreground-950">演员名单</h2>
        <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
          {cast.length} 位主演
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {cast.map((member) => (
          <div
            key={`${member.name}-${member.role}`}
            className="group flex flex-col items-center rounded-lg border border-background-200 bg-background-50 p-4 text-center transition-colors hover:border-accent-300"
          >
            <div className="h-20 w-20 overflow-hidden rounded-full md:h-24 md:w-24">
              <img
                src={member.avatar}
                alt={`${member.name} 演员头像`}
                title={`${member.name} 饰 ${member.role}`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <p className="mt-3 text-sm font-medium text-foreground-950">{member.name}</p>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">饰 {member.role}</p>
          </div>
        ))}
      </div>
    </section>
  );
}